import { render, staticRenderFns } from "./ChatActiveResultCard.vue?vue&type=template&id=61e362d6&scoped=true&"
import script from "./ChatActiveResultCard.vue?vue&type=script&lang=js&"
export * from "./ChatActiveResultCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatActiveResultCard.vue?vue&type=style&index=0&id=61e362d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e362d6",
  null
  
)

export default component.exports